import { Button } from '@rr/ui'
import { ArrowRight, Sparkles } from 'lucide-react'
import { APP_URL } from '../lib/links'
import { QuoteMock } from './mocks/QuoteMock'

export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-border">
      <div className="absolute inset-0 bg-grid pointer-events-none" aria-hidden />
      <div className="absolute inset-0 bg-hero-glow pointer-events-none" aria-hidden />

      <div className="relative max-w-6xl mx-auto px-6 lg:px-10 pt-20 pb-16 lg:pt-28 lg:pb-24">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 eyebrow text-primary mb-6">
            <Sparkles className="w-3 h-3" /> Logistika OS-i
          </p>
          <h1 className="text-[36px] sm:text-[48px] lg:text-[60px] leading-[1.05] font-semibold tracking-tight text-foreground">
            Bahala. Hasapla. Ýük gazan.
            <br />
            <span className="text-muted-foreground">Tablisalar ýok.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-muted-foreground max-w-xl leading-relaxed">
            Senariýalar dörediň, hasaplamalary işlediň, müşderiniň jogap berip biljek
            bahalaryny iberiň — ýeňiji teklip bir basmakda sargyda öwrülýär.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Button asChild size="lg">
              <a href={APP_URL} className="gap-2">
                Programmany aç
                <ArrowRight className="w-4 h-4" />
              </a>
            </Button>
            <Button asChild size="lg" variant="outline">
              <a href="#concepts">Nähili işleýär</a>
            </Button>
          </div>
        </div>

        <div className="mt-14 lg:mt-20">
          <QuoteMock />
        </div>
      </div>
    </section>
  )
}
